import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useParams} from 'react-router-dom';
import {getAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp } from "../../services/Util";
import TreeView from "../../pages/TreeView";
import Constants from "../../Constants";
import { updateTreeValue, updateTab, updateTreeData, addChildrenToTreeData, updateSelectedTreeNode,setSelectedTreeData } from "../../redux/reducers/TreeSlice";
import { updateCredentialsSet, updateProjectContentType } from "../../redux/reducers/ProjectInfoSlice"
import { transformBlankToNull } from '../../services/Util';
import UberflipCredential from "../../pages/settings/integrationSettings/UberflipCredential";
import jQuery from "jquery";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../SuccessMessage";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { logError } from "../../services/authApiRoutes/APImethods";

export default function UberflipIntegration (props) {

    const params = useParams();
    const dispatch = useDispatch();
    const TreeViewMemo = React.memo(TreeView);
    const UberflipCredentialMemo = React.memo(UberflipCredential);
    const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;

    const [credentialData, setCredentialData] = useState();
    const [serverErrorMessage, setServerErrorMessage] = useState([]);
    const [isValidating, setValidating] = useState(false);
    const [successMessage, setSuccessMessage] = useState();
    const [message, setMessage] = useState(Constants.BLANK);
    const [showCredential, setShowCredential] = useState(false);
    const [childData, setChildData] = useState();
    const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData
    const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
    const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;

    const dispatchDataToTreeSliceRedux = (type, value) => {		
		dispatch(updateTreeValue({
		  type: type,
		  value: value
		}));
	} 

    const tabs = [
      {
        label: "Blog",
        isActive: true
      }
    ]

    const showCredentialModel = () => {
      setShowCredential(true);
      document.body.classList.add("modal-open");
    };

    const hideCredentialModel = () => {
      setShowCredential(false);
      setValidating(false);
      document.body.classList.remove("modal-open");
    };

    useEffect(() => {
      getCredential(Constants.UBERFLIP);
      if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
        dispatchDataToTreeSliceRedux("selectedTreeNode", {});
      }
      if(selectedTreeData && selectedTreeData.length===0){
        getExistingSelection(Constants.UBERFLIP)
         }
    }, []);

    const onTabChange = (tab) => {
        
    }

    const getExistingSelection = (service) => {
      const dateTimestamp = dateConvertToTimeStamp();

      if (props.projectRequestId || projectData?.id) {
        let urlString = APIUrls.CUSTOMER_PROJECT_ASSET_CONFIGURATION(projectData?.id);
        if (props.isProjectRequest && props.projectRequestId) {
          urlString = APIUrls.CUSTOMER_PROJECT_REQUEST_ASSET_CONFIGURATION(props.projectRequestId)
        }
        getAxiosResponse(urlString + `?type=${service}&_=${dateTimestamp}`
        ).then((res) => {
          if (res.data.code === 200) {
            let data = []
            if (res.data?.data?.body && res.data?.data?.body?.length > 0) {
              res.data?.data?.body?.forEach(asset => {
                if ((asset.language === null) || (asset.language !== projectData?.sourceLanguage)) {
                  data?.push(asset);
                }
              })
              const result = Object.values(data.reduce((acc, curr, index) => {
                if (!acc[curr.externalId]) {
                  acc[curr.externalId] = { ...curr, assetName:curr?.name,language: [curr.language] };
                } else {
                  if (!acc[curr.externalId].language.includes(curr.language)) {
                    acc[curr.externalId].language.push(curr.language);
                  }
                }
                return acc;
              }, {}));
              result?.map(r => r.assetName = r.name);
              dispatch(setSelectedTreeData(result))
            }
          }
        }).catch((err) => {
          handleError(err);
        });
      }
    };


    const loadUberflipTree = () => {
      setMessage("Please wait, your assets are being loaded...")
      if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
        dispatch(setSelectedTreeData([]));
       }
      dispatchDataToTreeSliceRedux("displayName", "assetName");
      dispatchDataToTreeSliceRedux("contentType", "Uberflip");
      dispatchDataToTreeSliceRedux("isTreeLoading", true);
      dispatch(updateTab(tabs))
      getFolders(0, 0);
    }

    useEffect(() => {
        const asset = treeValueRedux?.selectedTreeNode;
        if (asset?.assetId !== undefined) {
          if (asset?.assetType === Constants.BLOG_SMALL) {
            getFolderChildren(asset.assetId, 0, 0, setChildData);
          } else {
            getAssetChildren(asset.assetId, asset.assetType, 0, 0, setChildData);
          }
        }
    }, [treeValueRedux.selectedTreeNode])
    
    useEffect(() => {
        if (Array.isArray(childData) && childData?.length > 0) {
          let cloneNode = JSON.parse(JSON.stringify(treeValueRedux.selectedTreeNode))
          cloneNode.children = childData;
          dispatch(addChildrenToTreeData(cloneNode))
        }
    }, [childData])

    const submitCredential = () => {
      setSuccessMessage("Validating credentials...")
      setValidating(true);
      var isPost = true;
      let localCredentialData = JSON.parse(JSON.stringify(credentialData));
      localCredentialData.credentials = {
        'CLIENT_ID': jQuery("#uberflip-client-id-input").val(),
        'CLIENT_SECRET': jQuery("#uberflip-client-secret-input").val()
      };
      localCredentialData.credentialsType = "UBERFLIP"
      if(localCredentialData?.id){
        isPost = false;
      }
      putOrPostAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.UBERFLIP), localCredentialData, isPost
        ).then((res) => {
          setValidating(false);
          setSuccessMessage(Constants.BLANK)
          if (res.data?.handledMessage || res.data?.data?.handledMessage){
            setServerErrorMessage([res.data.handledMessage])
          } else {
            setServerErrorMessage([]);
            setSuccessMessage("Credential successfully updated!")
            hideCredentialModel();
          }
        }).catch((err) => {
          setValidating(false);
          const errorMessage = "err - ";
          logError(errorMessage, err); 
          setSuccessMessage(Constants.BLANK)
      })
    }

    const getCredential = (service) => {
      setValidating(true)
      setMessage("Checking credentials...")
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(service) + `?_=${dateTimestamp}`
      ).then (res => {
        setValidating(false)
        setMessage(Constants.BLANK)
        if (res.data.code === 200) {
          var credentialsSet = transformBlankToNull(res.data.data.body)
          setCredentialData(credentialsSet)
          dispatch(updateCredentialsSet(credentialsSet))
            dispatch(updateProjectContentType(Constants.UBERFLIP));
          if (credentialsSet !== null && credentialsSet.credentials !== null) {
            loadUberflipTree();
          } else {
            showCredentialModel();
          }
        }
      }).catch(err => {
        setMessage(Constants.BLANK)
        handleError(err);
        setValidating(false)
      });
    };

    const getFolders = (limit, offset) => {
        setValidating(true);
        setMessage("Fetching data...")
        const dateTimestamp = dateConvertToTimeStamp();
        let urlString = APIUrls.UBERFLIP_FOLDERS(params.id) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
        if (props.isProjectRequest) {
            urlString = APIUrls.UBERFLIP_FOLDERS_PROJECTLESS + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
        }

        getAxiosResponse(urlString
        ).then(res => {
            setValidating(false);
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
            setMessage(Constants.BLANK)
            if (res.data.code === 200) {
                let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
                dispatch(updateTreeData(assetList))  
              } 
        }).catch(err => {
            setValidating(false);
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
            setMessage(Constants.BLANK)
        })
    }

    const getFolderChildren = (folderId, limit, offset, setValue) => {
        const dateTimestamp = dateConvertToTimeStamp();
        dispatchDataToTreeSliceRedux("isTreeLoading", true);
        let urlString = APIUrls.UBERFLIP_FOLDER_CHILDREN(params.id, folderId) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`;
        if (props.isProjectRequest) {
            urlString = APIUrls.UBERFLIP_FOLDER_CHILDREN_PROJECTLESS(folderId) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`;
        }
        getAxiosResponse(
          urlString
        ).then((res) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
            if (res.data.code === 200) {
              let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
              setValue(assetList);
            }
        }).catch((err) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
          handleError(err);
        });
    };

    const getAssets = (limit, offset) => {
        dispatchDataToTreeSliceRedux("isTreeLoading", true);
        const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(APIUrls.UBERFLIP_ASSET(params.id) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
        ).then(res => {
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
            if (res.data.code === 200) {
                let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
                dispatch(updateTreeData(assetList))  
            } 
        }).catch(err => {
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
        })
    }

    const getAssetChildren = (assetId, assetType, limit, offset, setValue) => {
        const dateTimestamp = dateConvertToTimeStamp();
        dispatchDataToTreeSliceRedux("isTreeLoading", true);
        let urlString = APIUrls.UBERFLIP_ASSET_CHILDREN(params.id, assetId, assetType) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`;
        if (props.isProjectRequest) {
            urlString = APIUrls.UBERFLIP_ASSET_CHILDREN_PROJECTLESS( assetId, assetType) + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`;
        }
        getAxiosResponse(
          urlString
        ).then((res) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
            if (res.data.code === 200) {
              let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
              setValue(assetList);
            }
        }).catch((err) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
          handleError(err);
        });
    }

    const convertAssets = (assetTypeResponseList) => {
      let assets = transformBlankToNull(assetTypeResponseList)
      let assetList = [];
      assets?.map(asset => {
        asset.assetList.map(a => {
          a.assetType = asset.assetType;
          a.id = a.assetId;
          a.children = [];
          a.parentAssetUrl = treeValueRedux.selectedTreeNode?.assetUrl;
          a.parentAssetType = treeValueRedux.selectedTreeNode?.assetType;
          assetList.push(a)
        }); 
      })
      return assetList;
    }

    return (
        <>
            <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
            <div className="gb-loader">
                <RotatingLines
                    strokeColor="#0096FF"
                    strokeWidth="5"
                    width="196"
                    visible={true}
                />
                </div>
            </div> 
            {(message!==undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}

            {showCredential ? 
            (<div className="lightbox-panel sm-lg-lightbox-panel">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
            <strong>Uberflip API Settings</strong>
            <button className="close" aria-label="close popup" onClick={() => hideCredentialModel()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
            </button>
            </div>
            <div className="lightbox-content padd-22">
                <div className="flex">
                <div className="leftBlock">
                    <p>Manage your Uberflip login credentials for Uberflip Integration projects.</p>
                    <p>OPAL-Marketing accelerates and automates the localization process by integrating directly with Uberflip. 
                      The content can subsequently be translated into the desired languages and an in-context review can take 
                      place allowing reviewers to edit and comment on the content. After the translations have been approved, 
                      OPAL-Marketing automatically updates Uberflip with the translated emails.</p>
                </div>
                <div className="rightBlock">
                <div className="flex wrap-dropdown flex-column mb-0">
                  <UberflipCredentialMemo 
                    credentialData = {credentialData} 
                    errorMessages = {serverErrorMessage}
                    isValidating = {isValidating}
                    successMessage = {successMessage} 
                    closePopup = {hideCredentialModel}
                  />
                </div>
                </div>
                
                </div>
            </div>	
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="btn btn-bold" onClick={() => hideCredentialModel()}>Cancel</button>
                <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential()}>Save</button>
            </div>
            </div>		
            </div>) 
            :
            (<div>
            <TreeViewMemo onTabChange={onTabChange} />
            </div>) 
            }
        </>
    )
}